import { Component, OnInit, ViewChild } from '@angular/core';
import { PopupModel, PopupButton, PopupModelReturn, SP_Type, SPType_ServiceProvider, ServiceProvider, PopupSetupModel, Patient, CommunicationModel, ReportHistory } from '../../AllTableClasses';
import { PopupNotificationService } from '../../Services/popup-notification.service';
import { Router } from '@angular/router';
import { NotificationPopupComponent } from '../Components/notification-popup/notification-popup.component';
import { ServiceProviderService } from '../../Services/service-provider.service';
import { MembersService } from '../../Services/members.service';
import { PatientSetupPopupComponent } from '../Components/patient-setup-popup/patient-setup-popup.component';
import { CommunicationService } from '../../Services/communication.service';
import { ReportsService } from '../../Services/reports.service';
import { LoadingService } from '../../Services/loading.service';

@Component({
  selector: 'app-patients-main-page',
  templateUrl: './patients-main-page.component.html',
  styleUrl: './patients-main-page.component.scss'
})
export class PatientsMainPageComponent implements OnInit {

  public filterString: string = '';
  public includeInactive: boolean = false;

  @ViewChild('popup') popup!: NotificationPopupComponent;
  @ViewChild('patientPopup') ServicePopup!: PatientSetupPopupComponent;

  public patients: Array<Patient> = new Array<Patient>();

  public newPatientList: Array<Patient> = new Array<Patient>();
  //public progressPatientList: Array<Patient> = new Array<Patient>();
  public oldPatientList: Array<Patient> = new Array<Patient>();

  public filteredNewPatients: Array<Patient> = new Array<Patient>();
  //public filteredProgressPatients: Array<Patient> = new Array<Patient>();
  public filteredOldPatients: Array<Patient> = new Array<Patient>();

  public pagedNewPatients: Array<Patient> = new Array<Patient>();
  //public pagedProgressPatients: Array<Patient> = new Array<Patient>();
  public pagedOldPatients: Array<Patient> = new Array<Patient>();

  public selectedPatient: Patient = new Patient();
  public pageSize: number | null = 20;
  public reportParam: string = '';


  constructor(
    private router: Router,
    private popupNotificationService: PopupNotificationService,
    private membersService: MembersService,
    private communicationService: CommunicationService,
    private reportService: ReportsService,
    private loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.pageSize = 20;
    this.PatientSearch();
  }


  public SelectPatient(patient: Patient) {
    if (!patient.Selected) {
      this.selectedPatient = new Patient();
    } else {
      if (this.selectedPatient && this.selectedPatient.Guid !== patient.Guid) {
        this.selectedPatient.Selected = false;
      }
      this.selectedPatient = patient;
    }
  }

  public MemberGet() {
    this.selectedPatient = new Patient();

    this.membersService.MemberGet(this.filterString, this.includeInactive, (data) => {
      if (data.Success) {
        this.patients = data.Data;
        this.PatientListSort();

      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public PatientSearch() {
    if (this.pageSize == undefined) {
      this.MemberGet();
      return;
    }
    this.NewPatientsSearch();
    
    
    
  }


  public NewPatientsSearch() {
    this.selectedPatient = new Patient();

    this.membersService.NewPatientsSearch(this.filterString, this.includeInactive, this.pageSize, (data) => {
      if (data.Success) {
        this.newPatientList = data.Data;
        this.OldPatientsSearch();
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }
  //public InProgressPatientsSearch() {
  //  this.selectedPatient = new Patient();

  //  this.membersService.InProgressPatientsSearch(this.filterString, this.includeInactive, this.pageSize, (data) => {
  //    if (data.Success) {
  //      this.progressPatientList = data.Data;
  //      this.OldPatientsSearch();
  //    }
  //    else {
  //      console.log("Error: ", data.UserErrorMessage);
  //    }
  //  }, (error) => { });
  //}
  public OldPatientsSearch() {
    this.selectedPatient = new Patient();

    this.membersService.OldPatientsSearch(this.filterString, this.includeInactive, this.pageSize, (data) => {
      if (data.Success) {
        this.oldPatientList = data.Data;
        this.applyFilter();
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public PatientListSort() {
    this.newPatientList = this.patients.filter(p => p.Status == "NEW PATIENT");

    //this.progressPatientList = this.patients.filter(p => p.Status == "IN PROGRESS");

    this.oldPatientList = this.patients.filter(p => p.Status == "OLD PATIENT");
    this.applyFilter();
  }

  // Apply filter to all three lists based on the filterString
  public applyFilter() {
    this.filteredNewPatients = this.filterPatients(this.newPatientList);
    //this.filteredProgressPatients = this.filterPatients(this.progressPatientList);
    this.filteredOldPatients = this.filterPatients(this.oldPatientList);
    this.paginatePatient();
  }

  // Filter helper method
  public filterPatients(list: Array<Patient>): Array<Patient> {
    let filteredList: Array<Patient> = new Array<Patient>();

    if (this.filterString.trim() !== '')
    {
      filteredList = list.filter(patient => 
          patient.Name.toLowerCase().includes(this.filterString.toLowerCase()) ||
          patient.Surname.toLowerCase().includes(this.filterString.toLowerCase()) ||
          patient.IDNumber.toLowerCase().includes(this.filterString.toLowerCase())
      );
    }
    else {
      filteredList = list;
    }
     
    return filteredList;
  }
  paginatePatient() {
    this.pagedNewPatients = this.filteredNewPatients;
    //this.pagedProgressPatients = this.filteredProgressPatients;
    this.pagedOldPatients = this.filteredOldPatients;
  }
  // Event handlers for paginated items for each list
  public updatePaginatedNewPatients(pageItems: Array<Patient>): void {
    this.pagedNewPatients = [...pageItems];
  }

  //updatePaginatedProgressPatients(pageItems: Array<Patient>): void {
  //  this.pagedProgressPatients = [...pageItems];
  //}

  updatePaginatedOldPatients(pageItems: Array<Patient>): void {
    this.pagedOldPatients = [...pageItems];
  }

  public View(patient: Patient) {
    let patient_Setup: PopupSetupModel = new PopupSetupModel();
    patient_Setup.Title = 'Patient Details';
    patient_Setup.PopupAction = 'VIEW';
    patient_Setup.Data = patient;
    patient_Setup.Button = new PopupButton('Clear', 'Clear');
    patient_Setup.AltButton = new PopupButton('Back', 'Cancel');

    this.popupNotificationService.ShowPatientSetupPopup(patient_Setup).then((res: PopupModelReturn) => {
      if (res.Result === 'Clear') {
        let patient: Patient = new Patient();
        patient = res.Data;
        this.ClearPatientHistory(patient);
      }
      else {
      }
    });
  }

  public Add() {
    let patient: Patient = new Patient();
    let patient_Setup: PopupSetupModel = new PopupSetupModel();
    patient_Setup.Title = 'New Patient';
    patient_Setup.PopupAction = 'NEW';
    patient_Setup.Data = patient;
    patient_Setup.Button = new PopupButton('Save', 'Save');
    patient_Setup.AltButton = new PopupButton('Cancel', 'Cancel');

    this.popupNotificationService.ShowPatientSetupPopup(patient_Setup).then((res: PopupModelReturn) => {
      if (res.Result === 'Save') {
        let patient: Patient = new Patient();
        patient = res.Data;
        patient.Status = 'NEW PATIENT';
        this.MemberSetByGuid(patient);
      }
      else {
        console.log('Cancel clcked');
      }
    });
  }

  public Edit(patient: Patient) {
    let patient_Setup: PopupSetupModel = new PopupSetupModel();
    patient_Setup.Title = 'Edit Patient Details';
    patient_Setup.PopupAction = 'EDIT';
    patient_Setup.Data = patient;
    patient_Setup.Button = new PopupButton('Save', 'Save');

    this.popupNotificationService.ShowPatientSetupPopup(patient_Setup).then((res: PopupModelReturn) => {
      if (res.Result === 'Save') {
        this.MemberSetByGuid(res.Data);
      }
      else {
      }
    });
  }

  public Delete(patient: Patient) {
    let patient_Setup: PopupModel = new PopupModel();
    patient_Setup.Message = 'Are you sure you want to delete this Patient?';
    patient_Setup.MessageType = 'error';
    //service_Popup.Data = patient;
    patient_Setup.Button = new PopupButton('Delete', 'Delete');
    patient_Setup.AltButton = new PopupButton('Cancel', 'Cancel');

    this.popupNotificationService.ShowPopup(patient_Setup).then((res: PopupModelReturn) => {
      if (res.Result === 'Delete') {
        patient.Active = false;
        this.MemberSetByGuid(patient);
      }
      else {
        console.log('Cancel clcked');
      }
    });
  }

  public Retry(patient: Patient) {
    let patient_Setup: PopupSetupModel = new PopupSetupModel();
    patient_Setup.Title = 'New Patient';
    patient_Setup.PopupAction = 'NEW';
    patient_Setup.Data = patient;
    patient_Setup.Button = new PopupButton('Save', 'Save');
    patient_Setup.AltButton = new PopupButton('Cancel', 'Cancel');

    this.popupNotificationService.ShowPatientSetupPopup(patient_Setup).then((res: PopupModelReturn) => {
      if (res.Result === 'Save') {
        this.MemberSetByGuid(res.Data);
      }
      else {
      }
    });
  }




  public ClearPatientHistory(patient: Patient) {
    let service_Popup: PopupModel = new PopupModel();
    service_Popup.Message = "Are you sure you want to clear this Patient's History?";
    service_Popup.MessageType = 'error';
    //service_Popup.Data = patient;
    service_Popup.Button = new PopupButton('Clear', 'ClearHistory');
    service_Popup.AltButton = new PopupButton('Cancel', 'Cancel');
    this.popupNotificationService.ShowPopup(service_Popup).then((res: PopupModelReturn) => {
      if (res.Result === 'ClearHistory') {
        this.ActivityHistorySetInactive(patient);
      }
      else {
        console.log('Cancel clcked');
      }
    });
  }

  public ActivityHistorySetInactive(patient: Patient) {
    this.membersService.ActivityHistorySetInactive(patient, (data) =>
    {
      if (data.Success) {
        this.showNotifcationPopup(data.Success);
      }
      else {
        //console.log(data);
        this.showNotifcationPopup(data.Success, data.UserErrorMessage);
      }
    }, (error) => { console.log(error); });
  }

  public MemberSetByGuid(patient: Patient) {

    this.membersService.MemberSetByGuid(patient, (data) => {
      if (data.Success)
      {
        if (patient.Active == true && patient.ContactMethod == 'SMS') {
          this.SendConfirmationSMS(patient);
        }
        //else if (patient.Active == true && patient.ContactMethod == 'Email') {
        //  this.SendConfirmationEmail(patient);
        //}
        else
        {
          this.showNotifcationPopup(data.Success);
        }
      }
      else {
        //console.log(data);
        this.showNotifcationPopup(data.Success, data.UserErrorMessage, patient);
      }
    }, (error) => { console.log(error); });
  }


  public SendConfirmationSMS(patient: Patient) {
    let communication: CommunicationModel = new CommunicationModel();
    communication.Body = `Dear ${patient.Name}, ${patient.Surname}. Thank you for registering with HASS. Your registration is complete.`;
    communication.AgentID = patient.ID;
    communication.To = patient.Cellphone;
    this.communicationService.SendSMS(communication, (data) => {
      if (data.Success) {
        this.showNotifcationPopup(data.Success);
      }
      else {
        //console.log('Error: ', data.UserErrorMessage);
        this.showNotifcationPopup(data.Success, data.UserErrorMessage);
      }
    }, (error) => { });
  }

  //public SendConfirmationEmail(patient: Patient) {
  //  let communication: CommunicationModel = new CommunicationModel();
  //  communication.AgentID = patient.ID;
  //  communication.To = patient.Email;
  //  communication.Subject = 'HASS Registration Confirmation';
  //  communication.Body = 'Thank you for registering with HASS. Your registration is complete.';
  //  communication.Body = `<h4>Dear ${patient.Name}, ${patient.Surname}.</h4><br><p>Thank you for registering with HASS. Your registration is complete.</p>`

  //  this.communicationService.SendEmail(communication, (data) => {
  //    if (data.Success) {
  //      this.showNotifcationPopup(data.Success);
  //    }
  //    else {
  //      //console.log('Error: ', data.UserErrorMessage);
  //      this.showNotifcationPopup(data.Success, data.UserErrorMessage);
  //    }
  //  }, (error) => { });
  //}

  onGenerateReport(rendertype: string) {
    let report: ReportHistory = new ReportHistory();
    report.FileName = 'PatientsReport';
    report.FilePath = 'PatientsReport.rdl';
    const reportPath = report.FilePath;
    const reportName = report.FileName;

    const parameters = {
      Status: this.reportParam,
    }; // Add any required parameters here
    this.loadingService.show();

    this.reportService.GenerateReport(reportPath, reportName, parameters, rendertype, (data) => {
      this.loadingService.hide();
      if (data instanceof Blob) {
        if (rendertype == 'PDF') {
          const blob = new Blob([data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${reportName}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          const blob = new Blob([data], { type: "application/vnd.ms-excel" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${reportName}.xls`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }

        report.Action = 'Report Downloaded';
        //this.ReportActivityHistorySet(report);

      } else if (data.Success === false) {
        // If there's an error, display the error message
        this.loadingService.hide();
        this.showNotifcationPopup(data.Success, data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public showNotifcationPopup(success: boolean, message?: string, patient?: Patient) {
    let notificationPopup: PopupModel = new PopupModel();
    notificationPopup.Message = 'Updated Successfully';
    notificationPopup.MessageType = 'success';
    //notificationPopup.Button = new PopupButton('Cancel', 'routeToPatients');
    notificationPopup.Button = new PopupButton('Calendar', 'routeToCalendar');

    if (success == true) {
      this.popupNotificationService.ShowPopup(notificationPopup).then((res: PopupModelReturn) => {
        if (res.Result === 'routeToPatients') {
          this.router.navigate(['scheduler']);
          return;
        }
        else {
          this.PatientSearch();
        }
      });
    }
    else {
      notificationPopup.Message = message;
      notificationPopup.MessageType = 'error';
      notificationPopup.AltButton = new PopupButton('Retry', 'retry');
      this.popupNotificationService.ShowPopup(notificationPopup).then((res: PopupModelReturn) => {
        if (res.Result === 'retry' && patient) {
          this.Retry(patient);
        }
      });
    }

  }
}
